module.exports = __webpack_public_path__ + "media/application/images/ui/menu-table-ecfd7e266dbd811966d9a5f7bca1a1a6.svg";